// removed by extract-text-webpack-plugin
module.exports = {"page-menus":"page-menus--1atCnM","menu-group":"menu-group--_FAIjx","menu-item-icon":"menu-item-icon--_82GFh","menu-tip-icon":"menu-tip-icon--29SJvw"};